import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/visitors" },
    { path: "/join/:token", name: "join", component: () => import("@/views/VisitorsView.vue") },
    { path: "/visitors/:entityId?", name: "visitors", component: () => import("@/views/VisitorsView.vue") },
    { path: "/statistics", name: "statistics", component: () => import("@/views/StatisticsView.vue") },
    { path: "/quality/:traceId?", name: "quality", component: () => import("@/views/QualityView.vue") },
    { path: "/settings", name: "settings", component: () => import("@/views/SettingsView.vue") }
  ]
});

export default router;
